export interface IMessagesState {
	unreadCount: number | null,
	offset: number,
	limit: number,
	page: number,
	orderBy: { [key: string]: string }
	messageType: string,
	filterRecipient: string | null,
	filterAssignee: Array<string>,
	filterLabel: Array<string>,
	filterDateRange: Array<string>,
	filterSearch: string,
	filterLinked: Array<boolean>
}

const state: IMessagesState = {
	unreadCount: null,
	offset: 0,
	limit: 25,
	page: 1,
	orderBy: { received_at: 'desc' },
	messageType: 'IN',
	filterRecipient: null,
	filterAssignee: [],
	filterLabel: [],
	filterDateRange: [],
	filterSearch: '',
	filterLinked: [true, false]
};

const mutations = {
	SET_UNREAD_COUNT: (state, data) => {
		state.unreadCount = data;
	},
	SET_OFFSET: (state, data) => {
		state.offset = data;
	},
	SET_LIMIT: (state, data) => {
		state.limit = data;
	},
	SET_PAGE: (state, data) => {
		state.page = data;
	},
	SET_ORDER_BY: (state, data) => {
		state.orderBy = data;
	},
	SET_MESSAGE_TYPE: (state, data) => {
		state.messageType = data;
	},
	SET_FILTER_RECIPIENT: (state, data) => {
		state.filterRecipient = data;
	},
	SET_FILTER_ASSIGNEE: (state, data) => {
		state.filterAssignee = data;
	},
	SET_FILTER_LABEL: (state, data) => {
		state.filterLabel = data;
	},
	SET_FILTER_DATE_RANGE: (state, data) => {
		state.filterDateRange = data;
	},
	SET_FILTER_SEARCH: (state, data) => {
		state.filterSearch = data;
	},
	SET_FILTER_LINKED: (state, data) => {
		state.filterLinked = data;
	},
	RESET_FILTERS: (state) => {
		state.filterAssignee = [];
		state.filterLabel = [];
		state.filterDateRange = [];
		state.filterSearch = '';
		state.filterLinked = [true, false];
	}
};

export default {
	namespaced: true,
	state,
	mutations
};
